import {Dispatch} from "redux";

import {abTestingSelector} from "@pg-mono/ab-testing";
import {IFetchContext} from "@pg-mono/data-fetcher";
import {appendQueryString, getRequest} from "@pg-mono/request";
import {createRequestActionTypes} from "@pg-mono/request-state";
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {DSA_RATING_SORT_AB_TEST_ID, isDsaRatingSortTreatmentVariant} from "../../../ab_testing/dsa_rating_sort_ab_test";
import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {IRootState} from "../../../store/store";
import {getFetchOfferListQueryData} from "../helpers/get_fetch_offer_list_query_data";
import {IOfferListResponse} from "../types/IOfferListResponse";
import {hasPriceFilter} from "../utils/has_price_filter";

const FETCH_ALL_OFFERS_FOR_COUNT_PREFIX = "offer_list/FETCH_ALL_OFFERS_FOR_COUNT";
export const fetchAllOffersForCountTypes = createRequestActionTypes(FETCH_ALL_OFFERS_FOR_COUNT_PREFIX);

const offerListLink = apiV2ListLink.offer.list(Scenario.OFFER_LIST);

export const fetchAllOffersForCount = (ctx: IFetchContext<IRPRequestMeta>) => async (dispatch: Dispatch, getState: () => IRootState) => {
    const {count, latestQuery} = getState().offerList.list;
    if (!count) {
        dispatch({type: fetchAllOffersForCountTypes.reset});
        return;
    }

    if (!hasPriceFilter(latestQuery)) {
        dispatch({type: fetchAllOffersForCountTypes.reset});
        return;
    }

    // Clear previous `allOffers` immediately so listing/pagination never uses results from another query
    // while this multi-page fetch is in flight.
    dispatch({type: fetchAllOffersForCountTypes.reset});
    dispatch({type: fetchAllOffersForCountTypes.start});

    const useDsaSort = isDsaRatingSortTreatmentVariant(abTestingSelector(DSA_RATING_SORT_AB_TEST_ID)(getState()));
    const {fullQuery} = getFetchOfferListQueryData(latestQuery as Record<string, string | string[] | null>, true, useDsaSort);
    const pageSize = Number(fullQuery.page_size);
    if (!("page_size" in fullQuery) || pageSize <= 0) {
        dispatch({type: fetchAllOffersForCountTypes.reset});
        return;
    }
    const numPages = Math.ceil(count / pageSize);

    const pageRequests = Array.from(
        {length: numPages},
        (_, index) => getRequest(ctx.meta, appendQueryString(offerListLink, {...fullQuery, page: index + 1})) as Promise<IOfferListResponse>
    );

    return Promise.all(pageRequests)
        .then((responses) => {
            const allOffers = responses.flatMap((response) => response.results);
            dispatch({type: fetchAllOffersForCountTypes.success, result: {allOffers}});
        })
        .catch(() => {
            dispatch({type: fetchAllOffersForCountTypes.error});
        });
};
import {Dispatch} from "redux";

import {abTestingSelector} from "@pg-mono/ab-testing";
import {IFetchContext} from "@pg-mono/data-fetcher";
import {appendQueryString, getRequest} from "@pg-mono/request";
import {createRequestActionTypes} from "@pg-mono/request-state";
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {DSA_RATING_SORT_AB_TEST_ID, isDsaRatingSortTreatmentVariant} from "../../../ab_testing/dsa_rating_sort_ab_test";
import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {IRootState} from "../../../store/store";
import {getFetchOfferListQueryData} from "../helpers/get_fetch_offer_list_query_data";
import {IOfferListResponse} from "../types/IOfferListResponse";
import {hasPriceFilter} from "../utils/has_price_filter";

const FETCH_ALL_OFFERS_FOR_COUNT_PREFIX = "offer_list/FETCH_ALL_OFFERS_FOR_COUNT";
export const fetchAllOffersForCountTypes = createRequestActionTypes(FETCH_ALL_OFFERS_FOR_COUNT_PREFIX);

const offerListLink = apiV2ListLink.offer.list(Scenario.OFFER_LIST);

export const fetchAllOffersForCount = (ctx: IFetchContext<IRPRequestMeta>) => async (dispatch: Dispatch, getState: () => IRootState) => {
    const {count, latestQuery} = getState().offerList.list;
    if (!count) {
        dispatch({type: fetchAllOffersForCountTypes.reset});
        return;
    }

    if (!hasPriceFilter(latestQuery)) {
        dispatch({type: fetchAllOffersForCountTypes.reset});
        return;
    }

    // Clear previous `allOffers` immediately so listing/pagination never uses results from another query
    // while this multi-page fetch is in flight.
    dispatch({type: fetchAllOffersForCountTypes.reset});
    dispatch({type: fetchAllOffersForCountTypes.start});

    const useDsaSort = isDsaRatingSortTreatmentVariant(abTestingSelector(DSA_RATING_SORT_AB_TEST_ID)(getState()));
    const {fullQuery} = getFetchOfferListQueryData(latestQuery as Record<string, string | string[] | null>, true, useDsaSort);
    const pageSize = Number(fullQuery.page_size);
    if (!("page_size" in fullQuery) || pageSize <= 0) {
        dispatch({type: fetchAllOffersForCountTypes.reset});
        return;
    }
    const numPages = Math.ceil(count / pageSize);

    const pageRequests = Array.from(
        {length: numPages},
        (_, index) => getRequest(ctx.meta, appendQueryString(offerListLink, {...fullQuery, page: index + 1})) as Promise<IOfferListResponse>
    );

    return Promise.all(pageRequests)
        .then((responses) => {
            const allOffers = responses.flatMap((response) => response.results);
            dispatch({type: fetchAllOffersForCountTypes.success, result: {allOffers}});
        })
        .catch(() => {
            dispatch({type: fetchAllOffersForCountTypes.error});
        });
};
